"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMultiInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const dropdown_1 = require("../../dropdown");
const DropdownMultiInput = ({ control, name, label, disabled, options, transformer, searchable, disableSort, extraContent, rules, }) => {
    const { field, fieldState: { error }, } = (0, react_hook_form_1.useController)({ control, name, rules });
    return (react_1.default.createElement(dropdown_1.Dropdown, { style: dropdown_1.Dropdown.STYLES.LIGHT, type: dropdown_1.Dropdown.TYPES.VARIABLE, size: dropdown_1.Dropdown.SIZES.FULL_WIDTH, extraDropdownContent: extraContent, label: label, options: options, singleSelect: false, searchable: searchable, disableSort: disableSort, value: transformer.in(field.value), onChange: (v) => {
            field.onChange(transformer.out(v));
        }, disabled: field.disabled || disabled, hasError: (0, util_1.isDefined)(error), errorMessage: error?.message }));
};
exports.DropdownMultiInput = DropdownMultiInput;
